import axios from 'axios'

export const sendContact = (data: FormData): Promise<any> => axios.post('v1/catalogo/contact', data, {
  headers: {
    'Content-Type': 'multipart/form-data',
  },
})